import { useEffect } from 'react';

// While `active`, scrolling (mouse wheel / touch drag) with the cursor over
// the element in `ref` does nothing — it doesn't scroll the table/page
// behind it. Outside the element, scrolling works as normal.
//
// Used for the Filter / Sort popovers in StudentListTable and
// StaffListTable. React's onWheel is passive and can't preventDefault,
// so this attaches native non-passive listeners instead.
const useBlockScrollThrough = (ref, active) => {
    useEffect(() => {
        const el = ref.current;
        if (!active || !el) return undefined;
        const block = (e) => {
            e.preventDefault();
        };
        el.addEventListener('wheel', block, { passive: false });
        el.addEventListener('touchmove', block, { passive: false });
        return () => {
            el.removeEventListener('wheel', block);
            el.removeEventListener('touchmove', block);
        };
    }, [ref, active]);
};

export default useBlockScrollThrough;
